module.exports = __webpack_public_path__ + "img/bs_banner_hk.7d35bf0e.jpg";